import React, { useState, useEffect } from "react";

import { connect } from "react-redux";
import history from "../../history";

const Shifts = ({ appData: { candidateId } }) => {
  const [iframeUrl, setIframeUrl] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [iframeHeight, setIframeHeight] = useState(600); // Default height

  useEffect(() => {
    // Get the base URL dynamically from the current window location
    const getBaseUrl = () => {
      const { protocol, hostname, port } = window.location;
      const portString = port ? `:${port}` : "";
      return `${protocol}//${hostname}${portString}`;
    };

    const baseUrl = getBaseUrl();
    const shiftPlannerUrl = `${baseUrl}/my-account/shifts?candidate_id=${candidateId}`;

    setIframeUrl(shiftPlannerUrl);
    setLoading(false);
  }, [candidateId]);

  useEffect(() => {
    const handleMessage = (event) => {
      const allowedOrigins = [
        "https://font.localhost:4001",
        "https://font.staging.hrgolabs.dev",
        "https://font.demo.hrgolabs.dev",
        "https://font.hrgolabs.dev",
        "https://staging.hrgolabs.dev",
        "https://www.hrgo.co.uk",
      ];

      if (!allowedOrigins.includes(event.origin)) {
        return;
      }

      if (event.data.type === "iframe-height") {
        const minHeight = 400;
        const newHeight = Math.max(event.data.height, minHeight);
        setIframeHeight(newHeight);
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  const handleIframeLoad = () => {
    setLoading(false);
    setError(null);
  };

  const handleIframeError = () => {
    setLoading(false);
    setError(
      "Failed to load shifts. Please check your authentication or try refreshing the page."
    );
  };

  return (
    <div className="container">
      {loading && (
        <div className="text-center p-4">
          <div className="spinner-border" role="status">
            <span className="sr-only">Loading shifts...</span>
          </div>
          <p className="mt-2">Loading your shifts...</p>
        </div>
      )}

      {error && (
        <div className="alert alert-warning" role="alert">
          <h4 className="alert-heading">Unable to load shifts</h4>
          <p>{error}</p>
          <hr />
          <p className="mb-0">
            <a
              href={iframeUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary"
            >
              Open Shifts in New Tab
            </a>
          </p>
        </div>
      )}

      {iframeUrl && (
        <iframe
          src={iframeUrl}
          title="Shifts Scheduler"
          className="w-100"
          style={{
            marginTop: "28px",
            height: `${iframeHeight}px`,
            border: "none",
            borderRadius: "0.375rem",
            display: loading || error ? "none" : "block",
            transition: "height 0.3s ease", // Smooth height transitions
          }}
          onLoad={handleIframeLoad}
          onError={handleIframeError}
          sandbox="allow-scripts allow-forms allow-popups allow-top-navigation"
        />
      )}

      <div
        className="container"
        style={{
          display: "flex",
          padding: "30px 0",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <button
          onClick={() => history.push("/profile")}
          className="btn"
          style={{ backgroundColor: "lightgray" }}
        >
          Back to My Account
        </button>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  appData: state.core.app,
});

const withRedux = connect(mapStateToProps, null);

export default withRedux(Shifts);
